// extracted by mini-css-extract-plugin
export default {"container":"our_services_container__p1bj-","circle":"our_services_circle__tGgvy","circle2":"our_services_circle2__SMvft","poligon":"our_services_poligon__R+89h"};